import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, FileText, Shield } from "lucide-react";
import { useState } from "react";
import { useProfile } from "@/hooks/useProfile";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";
import logoImage from "@/assets/logo-corre-digital.png";

export default function EmpresaTermos() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { updateProfile } = useProfile();
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    if (!accepted || !user) return;
    setLoading(true);
    try {
      await updateProfile.mutateAsync({ terms_accepted_at: new Date().toISOString() });
      navigate("/empresa", { replace: true });
    } catch {
      toast.error("Erro ao registrar aceite dos termos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-8">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-lg">
        <img src={logoImage} alt="Corre Digital" className="h-10 mx-auto mb-6" />

        <h1 className="font-heading text-2xl font-bold text-foreground text-center mb-2">Termos de Uso</h1>
        <p className="text-muted-foreground text-center mb-8">Primeiro acesso — leia e aceite para continuar</p>

        <div className="bg-card rounded-2xl p-6 border border-border mb-6">
          <div className="flex items-start gap-3 mb-4">
            <FileText className="w-5 h-5 text-primary shrink-0 mt-0.5" />
            <div>
              <p className="font-medium text-foreground mb-2">Uso de Dados de Talentos</p>
              <p className="text-sm text-muted-foreground">
                Os dados disponibilizados na plataforma são exclusivamente para fins de recrutamento e curadoria de talentos.
              </p>
            </div>
          </div>
          <ul className="text-sm text-muted-foreground space-y-2 ml-8 mb-4">
            <li>• Compartilhar dados com terceiros é proibido</li>
            <li>• Contatar talentos fora da plataforma é proibido</li>
            <li>• O acesso é registrado para fins de auditoria (LGPD)</li>
          </ul>
        </div>

        <label className="flex items-center gap-3 mb-6 cursor-pointer">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            className="w-5 h-5 rounded border-input accent-primary"
          />
          <span className="text-sm text-foreground">Li e aceito os termos de uso.</span>
        </label>

        <Button variant="hero" size="xl" className="w-full" onClick={handleAccept} disabled={!accepted || loading}>
          <CheckCircle2 className="w-5 h-5" />
          Aceitar e Continuar
        </Button>

        <p className="text-xs text-muted-foreground text-center mt-4">
          Data/hora do aceite será registrada para auditoria.
        </p>
      </motion.div>
    </div>
  );
}
